module.exports = __webpack_public_path__ + "static/wapp-conversacion-768px-d1d6e81ef19b9b19a10d7d357d958c6c.gif";